import { SelectModalM } from "@common/components/select/selectSingle-Multiple"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { weekDaysObject } from "@data/constants/activitiesConstants"
import { padToTwo } from "@data/utility/Utils"
import React, { useState } from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import { SwitchComponent } from "../application/personalInfos/ApplicationPersonalInfos"

export const TutorSlotsPicker = (props) => {
    const { control, setFormValues, field, withSaturdayMorning = true } = props

    const [visible, setVisible] = useState(false)
    const [timePickerDay, setTimePickerDay] = useState(null)
    const [time, setTime] = useState("17:00")

    const weekDays = Object.keys(weekDaysObject)

    const handleShowModal = () => {
        setVisible(!visible)
    }

    // All :00 and :30 times, starting from 14:00 to 19:30
    const afternoonOptions = Array.from({ length: 12 }, (v, i) => {
        const hour = Math.floor(i / 2) + 14
        const minute = i % 2 === 0 ? "00" : "30"
        return padToTwo(hour) + ":" + padToTwo(minute)
    }).map((x) => ({ label: x, value: x }))

    const morningOnlyOptions = Array.from({ length: 6 }, (v, i) => {
        const hour = Math.floor(i / 2) + 9
        const minute = i % 2 === 0 ? "00" : "30"
        return padToTwo(hour) + ":" + padToTwo(minute)
    }).map((x) => ({ label: x, value: x }))

    const options =
        timePickerDay === "Saturday" ? morningOnlyOptions : afternoonOptions

    return (
        <ScrollView style={{}}>
            {weekDays
                ?.filter(
                    (x, index) =>
                        index < weekDays?.length - (withSaturdayMorning ? 1 : 2)
                )
                .map((weekDay) => {
                    const isDaySelected =
                        field.value?.filter((x) => x?.split(" ")[0] === weekDay)
                            .length > 0
                    const daySelectedTime = field.value
                        ?.find((x) => x?.split(" ")[0] === weekDay)
                        ?.split(" ")[1]

                    return (
                        <SwitchComponent
                            key={weekDay}
                            value={isDaySelected}
                            setValue={(value) => {
                                if (value) {
                                    field.onChange([
                                        ...field.value,
                                        weekDay + " " + time,
                                    ])
                                    setFormValues({
                                        ...control._formValues,
                                        availability_slots: [
                                            ...field.value,
                                            weekDay + " " + time,
                                        ],
                                    })
                                    setTimePickerDay(weekDay)
                                    handleShowModal()
                                } else {
                                    const selectedTime = field.value
                                        ?.find(
                                            (x) => x.split(" ")[0] === weekDay
                                        )
                                        ?.split(" ")[1]
                                    const newValues = [...field.value].filter(
                                        (x) =>
                                            x !== weekDay + " " + selectedTime
                                    )
                                    field.onChange(newValues)
                                    setFormValues({
                                        ...control._formValues,
                                        availability_slots: newValues,
                                    })
                                }
                            }}
                            label={weekDaysObject[weekDay]}
                            renderAdditionalComponent={() =>
                                isDaySelected && (
                                    <TouchableOpacity
                                        onPress={() => {
                                            setTimePickerDay(weekDay)
                                            handleShowModal()
                                        }}
                                    >
                                        <View
                                            style={{
                                                paddingHorizontal: 10,
                                                width: "100%",
                                            }}
                                        >
                                            <TextM color={theme.colors.grey}>
                                                à partir de{" "}
                                                <TextM
                                                    fontWeight={"Bold"}
                                                    style={{
                                                        textDecorationLine:
                                                            "underline",
                                                    }}
                                                    color={theme.colors.link}
                                                >
                                                    {daySelectedTime}
                                                </TextM>
                                            </TextM>
                                        </View>
                                    </TouchableOpacity>
                                )
                            }
                        />
                    )
                })}

            {visible && (
                <SelectModalM
                    isMulti={false}
                    modalVisible={visible}
                    setModalVisible={handleShowModal}
                    title={`${
                        weekDaysObject?.[timePickerDay] ?? "Lundi"
                    } à partir de`}
                    selectedValue={time ?? "17:00"}
                    options={options}
                    valueMode={true}
                    onSingleSelect={(value) => {
                        handleShowModal()
                        setTime(value.value)
                        const newValues = field.value?.map((x) =>
                            x?.split(" ")[0] === timePickerDay
                                ? timePickerDay + " " + value.value
                                : x
                        )
                        field.onChange(newValues)
                    }}
                    itemHeight={50}
                />
            )}
        </ScrollView>
    )
}
